<template lang="pug">
    .icebreakerSlider
        .bg
            .left
            .right
        .closer_container
            Closer(v-if="!isMobileDevice" @click.native="$store.commit('closePopup')" data-hover :text="'Закрыть'")
        .swiper-container
            .swiper-wrapper
                .swiper-slide(v-for="slide in slides")
                    .title(v-html="slide.title")
                    .img(:style="{backgroundImage: 'url('+slide.img+')'}")
                    .text(v-html="slide.text")


</template>

<script>
    export default {
        name: "IcebreakerSlider",
        props: ['slides'],
        data:()=>({
            slider: null,
        }),
        computed:{
            isMobileDevice(){
                return this.$store.state.isMobileDevice;
            }
        },
        methods:{
            initSlider() {
                this.slider = new Swiper('.icebreakerSlider .swiper-container', {
                    speed: 500,
                    loop: true,
                    slidesPerView: 1.91,
                    grabCursor: true,
                    loopedSlides: 3,
                    centeredSlides: true,
                    spaceBetween: 100,
                    slideActiveClass: 'active',
                });
            },
        },
        created(){
          this.$store.state.whiteHeader = true;
        },
         mounted() {
            this.initSlider();
         },
        beforeDestroy(){
            this.$store.state.whiteHeader = false;
        },
    }
</script>





<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .icebreakerSlider {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        padding-top: 11.6vh;
        z-index: 50;
        .bg{
            position: absolute;
            top: 0;
            left: 0;
            width: 130vw;
            height: 100%;
            margin-left: -15vw;
            display: flex;
            .left, .right {
                transform: skewX(-28.4deg) translate3d(0, 0, 0);
            }
            .left {
                width: 47.5%;
                background: url(../../assets/img/concurs/icebreaker_bg.jpg) no-repeat center center / cover;
            }
            .right {
                width: 52.5%;
                background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(15, 82, 182) 60%, rgb(30, 130, 245) 100%);
            }
        }

        .closer_container{
            width: 87.7vw;
            display: flex;
            justify-content: flex-end;
            margin: 0 auto 1.2vh;
        }
        .swiper-container{

        }
        .swiper-slide{
            display: flex;
            flex-direction: column;
            color: #fff;
            .title{
                margin-bottom: 2.2vh;
                font-size: 2.165vw;
                transition: .5s;
            }
            .img{
                height: 24vw;
                margin-bottom: 3vh;
                background: no-repeat center center / cover;
            }
            .text{
                width: 58%;
                align-self: flex-end;
                font-family: 'Fira Sans Extra Condensed', sans-serif;
                font-size: 0.9vw;
                line-height: 1.3;
                opacity: 0;
                transition: .5s;
            }
            &.active{
                .title{
                    color: $blue;
                }
                .text{
                    opacity: 1;
                }
            }
        }

    }
    @include razr1280{
        .icebreakerSlider .bg{
            width: 140vw;
            margin-left: -20vw;
        }
    }

</style>
